import React from 'react'
import PropTypes from 'prop-types'
import Flex from '../../components/Flex'
import Box from '../../components/Box'
import CodeElementContainer from './CodeElementContainer'

const StorybookComponentContainer = ({width, children, name, flexDirection, codeElementPadding, customCodeProps, customCodeElement, ...restProps}) => <Flex flexDirection={flexDirection} width='100%' alignItems='center' {...restProps}>
    <Box key='element' padding={codeElementPadding} w='100%'>{children}</Box>
    <CodeElementContainer name={name} width={width} customCodeProps={customCodeProps} customCodeElement={customCodeElement}>{children}</CodeElementContainer>
</Flex>

StorybookComponentContainer.defaultProps = {
    flexDirection: 'column',
    codeElementPadding: '0 0 8px 0',
    customCodeElement: null
}
StorybookComponentContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
    width: PropTypes.string,
    name: PropTypes.string,
    flexDirection: PropTypes.oneOf(['column', 'row']),
    codeElementPadding: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ]),
    customCodeProps: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string
    })),
    customCodeElement: PropTypes.elementType,

}
export default StorybookComponentContainer